/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useMemo } from 'react';
import clsx from 'clsx';

import { IconTextBlock } from '@marriott/mi-ui-library';
import { createAutoSuggestComplianceFormatter, isCNLocale } from '@marriott/shared/mi-helper-utils';
import type { WithAutoSuggestComplianceListProps } from '@marriott/shared/mi-helper-utils';

import { StyledAutoSuggestionsDiv } from './AutoSuggestions.styles';
import { autosuggestionsClickTrackingLoc } from '../../../constants/lib/constants';
import { getSearchFormClickTrackingLoc } from '../../../modules/utils/searchFormHelper';

//TODO : to remove types with any
interface AutoSuggestionsProp extends WithAutoSuggestComplianceListProps {
  optionsList: any;
  getItemProps: any;
  highlightedIndex: number | null;
  selectedItem: any;
  currentLocale?: string;
  inputValue?: string;
}
export const AutoSuggestions: FC<AutoSuggestionsProp> = ({
  optionsList,
  getItemProps,
  highlightedIndex,
  selectedItem,
  currentLocale,
  inputValue,
  autoSuggestComplianceList,
}) => {
  const formatAutoSuggestion = useMemo(
    () => (isCNLocale(currentLocale) ? createAutoSuggestComplianceFormatter(autoSuggestComplianceList) : undefined),
    [autoSuggestComplianceList, currentLocale]
  );

  return (
    <StyledAutoSuggestionsDiv data-testid="Suggested-Place">
      {optionsList?.map((item: any, index: number) => {
        let primaryDescription = item?.node?.primaryDescription;
        let secondaryDescription = item?.node?.secondaryDescription;

        if (formatAutoSuggestion) {
          ({ primaryDescription, secondaryDescription } = formatAutoSuggestion({
            suggestion: item?.node,
            index,
            inputValue,
          }));
        }

        return (
          <div
            className={clsx(
              highlightedIndex === index && 'mi-icon-text-block',
              selectedItem === item && 'mi-icon-text-block',
              'custom_click_track'
            )}
            role="option"
            aria-selected={selectedItem === item}
            custom_click_track_value={`${getSearchFormClickTrackingLoc(
              false,
              true
            )} | ${autosuggestionsClickTrackingLoc} ${item?.node?.primaryDescription} | internal`}
            {...getItemProps({
              key: item?.node?.description,
              index,
              item,
              className: highlightedIndex === index ? 'highlighted-item custom_click_track' : 'custom_click_track',
            })}
          >
            <IconTextBlock
              icon="location"
              primaryTextContent={primaryDescription}
              secondaryTextContent={secondaryDescription ? secondaryDescription : ''}
              primaryCustomClass={'text-primary-custom'}
              secondaryCustomClass={'text-secondary'}
            />
          </div>
        );
      })}
    </StyledAutoSuggestionsDiv>
  );
};
